export enum DisplayProps {
  showClasses = 'showClasses',
  showGroups = 'showGroups',
  showTeachers = 'showTeachers',
  showRooms = 'showRooms',
}
